import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
// import './assets/dist/leaflet.css';
import './assets/dist/animate.min.css';
import './assets/css/productfont.css';
import "./assets/css/common.css";
import "./assets/css/template1.scss";
import "./assets/css/template2.scss";
import "./assets/css/fonts.css";
import "./assets/css/backgroundImage.css";
import "./assets/css/template2menusecondstyles.css";
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import configureStore from './redux/store/configureStore';

import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import OffileDb from './config/pouchDB';
import cordovaConfig from './config/cordovaConfig';
import ReactGA from './config/ReactGA';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import ErrorBoundary from './components/ErrorBoundary';


const themesChanges = {
  template1: './index.css',
  template2: './index.css',
  template3: './index.css',
};

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'museo_sans300',
      'museo_sans500',
      'museo_sans900',
    ].join(','),
  },
});



const store = configureStore();
console.log(store)
const startApp = () => {
  const CHOSEN_TemplateID = store.getState().storeState.templateID;
  console.log(CHOSEN_TemplateID)
  var CHOSEN_THEME = CHOSEN_TemplateID == 1 || CHOSEN_TemplateID == 'null' ? 'template1' : (CHOSEN_TemplateID == 2 ? "template2" : "template3");
  const styleNode = document.createComment('inject-styles-here');
  document.head.insertBefore(styleNode, document.head.firstChild);
  console.log(CHOSEN_THEME)
  ReactDOM.render(
    <ErrorBoundary>
    <ThemeSwitcherProvider insertionPoint="inject-styles-here" defaultTheme={CHOSEN_THEME} themeMap={themesChanges}>
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <App />
              <div class="offline-msg">You are in offline mode.</div>
            </ThemeProvider>
          </Provider>
        </I18nextProvider>
      </React.StrictMode>
      </ThemeSwitcherProvider>   
      </ErrorBoundary>
    ,
    document.getElementById('root')
  );

}

function onResume() {
  // alert('resumed');
  localStorage.setItem('BotInnit', "false");
  //FCMPluginNG.onNotification( onNotificationCallback(data), successCallback(msg), errorCallback(err) )
  //Here you define your application behaviour based on the notification data.

}
function onPause() {
  window.TTS.speak("");
}

function onOffline() {
  // Handle the offline event
  console.log("device is in offline");
  document.querySelector('.offline-msg').style.display = 'block';
}

function checkNetwork() {
  if (window.cordova) {
    var networkState = window.navigator.connection.type;
    if (networkState == window.Connection.NONE) {
      document.querySelector('.offline-msg').style.display = 'block';
    }
  }
}

function onOnline() {
  // Handle the online event
  console.log("device is in online");
  document.querySelector('.offline-msg').style.display = 'none';
}

//ReactGA.initialize()
if (!window.cordova) {
  startApp()
  OffileDb.setDatabase()
  ReactGA.webappInit()
} else {
  document.addEventListener('deviceready', () => {
    startApp();
    OffileDb.setDatabase()
    cordovaConfig.init()
    checkNetwork();
    window.open = window.cordova.InAppBrowser.open;
    ReactGA.webappInit()
    // window.FCMPlugin.getToken(function (token) {
    //   console.log(token)
    //   localStorage.setItem('fcmToken', token);
    //   // if (window.cordova) {
    //   //   window.FCMPlugin.getToken(function (token) {
    //   //     localStorage.setItem('fcmToken', token);
    //   //   });
    //   // }
    // });
    // window.FCMPlugin.onNotification(function (data) {
    //   console.log("forgran1: ", data)
    //   var myNotiData = {
    //     page: data.page
    //   }
    //   if (data.wasTapped) {
    //     //Notification was received on device tray and tapped by the user.
    //       localStorage.setItem('notiRedPage', JSON.stringify(data));
    //       //store.dispatch({ type: 'SET_NOTI_OBJ', payload: JSON.stringify(myNotiData)})
    //   } else {
    //     //Notification was received in foreground. Maybe the user needs to be notified.
    //     // localStorage.setItem('notiRedPage', JSON.stringify(data));
    //     window.cordova.plugins.notification.local.schedule({
    //       title: data.title,
    //       text: data.body,
    //       page: data.page,
    //       chatType: data.chatType ? data.chatType : '',
    //       caseId: data.caseId ? data.caseId : '',
    //       senderObj: data.senderObj ? data.senderObj : '',
    //       applicant:  data.applicant ? data.applicant : '',
    //       foreground: true
    //     });
    //   }
    // });

    if(window.FirebasePlugin){
      window.FirebasePlugin.onTokenRefresh(function(fcmToken) {
        console.log("fcmToken", fcmToken);
        if(fcmToken){
          localStorage.setItem('fcmToken', fcmToken)
        }
      }, function(error) {
          console.error(error);
      });

      window.FirebasePlugin.hasPermission(function(hasPermission){
        console.log("Permission is " + (hasPermission ? "granted" : "denied"));
        if(!hasPermission){
          window.FirebasePlugin.grantPermission(function(hasPermission){
            console.log("Permission was " + (hasPermission ? "granted" : "denied"));
          });
        }
      });

    }

    // Foreground Local notification clicked
    // window.cordova.plugins.notification.local.on("click", function (notification) {
    //   console.log("forgran2: ", notification)
    //   if (window.location.hash != "#/layout/peerchat" || window.location.hash != "#/layout/chatwindow") {
    //     store.dispatch({ type: 'SET_NOTI_OBJ', payload: JSON.stringify(notification) })
    //   }
    // });
    document.addEventListener("resume", onResume, false);
    document.addEventListener("pause", onPause, true);
    document.addEventListener("offline", onOffline, false);
    document.addEventListener("online", onOnline, false);
  }, false);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
